export {
  useCookiebotCategoryConsent,
  useCookiebotConsent,
  useLockScrollWhenCookieBotActive,
} from './consent';
export type { CookiebotCategory, CookiebotConsent } from './consent';
export { default as ConsentGuard, default } from './consent-guard';
